<template>
  <div>  
    
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div> 
      <sidebar-component classMenu="Dashboard"></sidebar-component>

       
       <div class="page-wrapper">
         <!-- begin::navbar-->
         <navbar-component></navbar-component>
        <!--end::navbar -->
      
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                

                <div class="card-body" style="height:200px;">
                  
                  <h6 class="card-title" style="text-align: center;">Pusat Logistik Berikat</h6>
                  <h5 class="card-title" style="text-align: center;">PT Lautan Luas Tbk</h5>
                    

                </div>

                
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>



  </div>
</template>

<script> 

import sidebarComponent from './_partials/_sidebar'
import navbarComponent from './_partials/_navbar'
import footerComponent from './_partials/_footer'
 
 
export default {
  name: 'UserDashboard',
  components: {
    'sidebar-component':sidebarComponent,
    'navbar-component':navbarComponent,
    'footer-component':footerComponent,
  },
  props:{ 
  },
  data () {
  
    return {
      detailUser:[],
      company:[],
      isLoading: false,  
    }
  },
  computed: {
    myStyles () {
      return {
        height: '500px',
        position: 'relative'
      }
    }
  },
  watch: { 

  },
  methods: {
    
    loading(){
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },
 
    fetchIt() {
      // const userDatas     = this.$getUserInfo();
      // this.detailUser     = userDatas.sub;
      // this.company        = this.detailUser.company_detail;

      // if(this.detailUser.user_type == "BILLING" ){
      //   window.location.href = "/dashboard-billing";
      // }else{
      //   console.log("ok")
      // }
    },
 
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    

    },
    events: {

    },
    created: function() { 
 
    },
	mounted() {
        this.fetchIt();
        this.loading();
    }

}

</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}
.blur-content{
  filter: blur(5px); 
}

</style>